'use client'

import { IBasicInquiryLoadLite, useSession } from '@repo/sdk'
import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

export type Step = 'address-book' | 'check-company' | 'join-request' | 'new-company'

interface BookingModalContextProps {
  header: ReactNode | string
  inquiry: IBasicInquiryLoadLite
  inquiryLoadId?: number
  open: boolean
  setOpen: (open: boolean) => void
  setStep: (step: Step) => void
  setVat: (vat: string) => void
  step: Step
  subHeader?: string
  vat: string
}

const BookingModalContext = createContext<BookingModalContextProps>({} as BookingModalContextProps)

export const BookingModalContextProvider = ({
  children,
  inquiry,
}: {
  children: ReactNode
  inquiry: IBasicInquiryLoadLite
}) => {
  const { data } = useSession()
  const [step, setStep] = useState<Step>(data?.user?.company?.id ? 'address-book' : 'check-company')
  const [vat, setVat] = useState<string>('')
  const [open, setOpen] = useState<boolean>(false)

  const header = useMemo(() => {
    switch (step) {
      case 'address-book':
        return 'Confirm booking'
      case 'check-company':
        return 'Provide VAT No.'
      case 'join-request':
        return 'Contact us'
      case 'new-company':
        return 'Your company information'
    }
  }, [step, data?.user?.company])
  const subHeader = useMemo(() => {
    switch (step) {
      case 'check-company':
        return 'Please provide your company VAT number to verify your details'
    }
  }, [step, data?.user?.company])
  // useEffect(() => {
  //   update()
  // }, [step])

  return (
    <BookingModalContext.Provider
      value={{
        header,
        inquiry,
        open,
        setOpen,
        setStep,
        setVat,
        step,
        subHeader,
        vat,
      }}
    >
      {children}
    </BookingModalContext.Provider>
  )
}

export const useBookingModalContext = () => {
  const context = useContext(BookingModalContext)

  if (!context) {
    throw new Error('useBookingModalContext must be used within a BookingModalContextProvider')
  }

  return context
}
